import { NgModule } from '@angular/core';
import { TrimValueAccessor } from './trim-value-accessor';

@NgModule({
  declarations: [ TrimValueAccessor ],
  exports: [ TrimValueAccessor ]
})
export class TrimValueAccessorModule { }



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/~/ng-trim-value-accessor/src/module.ts